import { FaLeaf, FaTruck, FaIndustry, FaFlask, FaMicrochip, FaSnowflake, FaShield, FaGears } from "react-icons/fa6";

const homeData = {
  hero_section_home: {
    title: "Freshness, Preserved. Value, Delivered.",
    brand: "Zenvia Foods Private Limited",
    description: "From Farm to Fork, With Care • 100% Natural • International Standards",
    src: "videos/hero-bg.webm",
  },
  welcome_text_section: {
    title: "Welcome to Zenvia Foods",
    minisubline:
      "Transforming nature's bounty into high-quality fruit pulps, purees, and frozen products!",
    description:
      "At Zenvia Foods Fruit Pulp, we don't just process fruits—we preserve their essence. With a sharp focus on pulps, purees, and frozen products, we specialize in delivering consistent quality and authentic taste to global food brands and households alike. Sourced responsibly from farmers, processed with cutting-edge technology, and preserved naturally, Zenvia ensures the orchard's freshness reaches you—pure, safe, and year-round.",
  },
  why_choose_us: [
    {
      icon: <FaIndustry style={{ fontSize: "32px" }} />,
      title: "Farm-Fresh Sourcing",
      description:
        "Direct procurement from farmers and FPOs ensures consistent quality and supports rural communities.",
    },
    {
      icon: <FaLeaf style={{ fontSize: "32px" }} />,
      title: "Modern Processing Facility",
      description:
        "Located at our facility with state-of-the-art infrastructure and advanced equipment.",
    },
    {
      icon: <FaFlask style={{ fontSize: "32px" }} />,
      title: "Cold Chain Excellence",
      description:
        "Blast freezers, IQF tunnels, and –20°C storage ensure freshness and safety throughout the supply chain.",
    },
    {
      icon: <FaTruck style={{ fontSize: "32px" }} />,
      title: "Quality Assurance",
      description:
        "HACCP, FSSAI, and export-compliant laboratory testing for every batch with full traceability.",
    },
  ],
  our_products_section: {
    title: "Our Diverse Product Portfolio",
    description:
      "Explore our comprehensive range of premium fruit pulps including mango, avocado, guava, pineapple, passion fruit, jackfruit, coconut, chikoo, and specialty blends, designed to meet the needs of B2B buyers, retail brands, and export markets.",
  },
  category_feature_card: [
    {
      image: "media/New-Images/Mango.png",
      title: "Mango Pulp",
      description:
        "Premium mango pulp (Totapuri, Alphonso, Kesar) available in bulk aseptic packs, drums, and consumer-ready packs.",
      features: ["Bulk & retail packs", "Export quality"],
      link: "/products/mango-pulp",
    },
    {
      image: "media/New-Images/Avocado.png",
      title: "Avocado Pulp",
      description:
        "Rich and creamy avocado pulp, perfect for smoothies, desserts, and health-conscious food applications.",
      features: ["High in healthy fats", "Creamy texture", "Nutrient dense"],
      link: "/products/avocado-pulp",
    },
    {
      image: "media/New-Images/Guava.png",
      title: "Guava Pulp",
      description:
        "Fresh guava pulp with authentic taste and natural sweetness, perfect for beverages and food processing applications.",
      features: ["High vitamin C", "Natural sweetness", "Multiple varieties"],
      link: "/products/guava-pulp",
    },
    {
      image: "media/New-Images/Pineapple.png",
      title: "Pineapple Pulp",
      description:
        "Tropical pineapple pulp with tangy sweetness, ideal for desserts, smoothies, and beverages.",
      features: ["Tropical flavor", "Enzyme rich", "Premium quality"],
      link: "/products/pineapple-pulp",
    },
    {
      image: "media/New-Images/Passion fruit.png",
      title: "Passion Fruit Pulp",
      description:
        "Exotic passion fruit pulp with intense tropical flavor, perfect for premium beverages and desserts.",
      features: ["Intense tropical flavor", "Aromatic", "Premium exotic fruit"],
      link: "/products/passion-fruit-pulp",
    },
    {
      image: "media/New-Images/Jack fruit.png",
      title: "Jackfruit Pulp",
      description:
        "Sweet and aromatic jackfruit pulp, ideal for traditional desserts and innovative food applications.",
      features: ["Unique sweet flavor", "Traditional favorite", "Versatile applications"],
      link: "/products/jackfruit-pulp",
    },
    {
      image: "media/New-Images/Tender coconut.png",
      title: "Tender Coconut Pulp",
      description:
        "Fresh coconut pulp with natural sweetness, perfect for beverages, desserts, and culinary applications.",
      features: ["Natural coconut flavor", "Rich texture", "Tropical essence"],
      link: "/products/coconut-pulp",
    },
    {
      image: "media/New-Images/Chikkoo.png",
      title: "Chikoo (Sapota) Pulp",
      description:
        "Sweet and smooth chikoo pulp with natural caramel-like flavor, ideal for desserts and beverages.",
      features: ["Natural sweetness", "Smooth texture", "Caramel notes"],
      link: "/products/chikoo-pulp",
    },
    {
      image: "media/New-Images/Tender coconut with dates.png",
      title: "Tender Coconut Date Pulp",
      description:
        "Premium blend of coconut and date pulp, combining tropical and natural sweetness for unique applications.",
      features: ["Natural sweetness", "Unique blend", "Rich in nutrients"],
      link: "/products/coconut-date-pulp",
    },
  ],
  infrastructure_technology: {
    title: "Infrastructure & Technology",
    description: "Our state-of-the-art facility is equipped with cutting-edge technology and modern infrastructure to ensure the highest quality standards in fruit processing and preservation.",
    features: [
      {
        icon: <FaIndustry style={{ fontSize: "32px" }} />,
        title: "Facility",
        description: "Modern processing facility spread across acres with plug-and-play infrastructure designed for optimal food processing operations."
      },
      {
        icon: <FaSnowflake style={{ fontSize: "32px" }} />,
        title: "Advanced Cold Chain",
        description: "Blast freezers, IQF tunnels, and –20°C storage systems maintain product freshness from processing to delivery."
      },
      {
        icon: <FaMicrochip style={{ fontSize: "32px" }} />,
        title: "Automated Processing",
        description: "State-of-the-art automated processing lines ensure consistent quality, reduced contamination, and optimal efficiency."
      },
      {
        icon: <FaShield style={{ fontSize: "32px" }} />,
        title: "Quality Control Lab",
        description: "In-house laboratory with advanced testing equipment for microbiological, chemical, and nutritional analysis."
      },
      {
        icon: <FaGears style={{ fontSize: "32px" }} />,
        title: "Process Innovation",
        description: "Continuous R&D in processing techniques to maintain nutritional value while extending shelf life naturally."
      },
      {
        icon: <FaFlask style={{ fontSize: "32px" }} />,
        title: "Aseptic Processing",
        description: "Aseptic processing and packaging technology ensures product safety without compromising on taste or nutrition."
      }
    ]
  },
  zenviaQualityMark: {
    features: [
      "Farm-fresh sourcing from trusted farmers",
      "International quality standards (HACCP, FSSAI)",
      "Sustainability & farmer welfare commitment",
      "Full traceability from farm to end-customer"
    ],
    tagline: "From Farm to Fork, With Care"
  },
};

export default homeData;
